import { useRef, useEffect } from "react";
import { useScript, useLink, LoadingEnum } from "@perxis-auto/shared";
import { CUSTOM_WIDGET_ITEM_ID } from "../../../shared/config/widget.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import { loggerApp } from "../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectPage } from "../../../shared/store/installation/model/selectors/selectPage.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const { script, link, render, destroy, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { id } = item;
  const itemId = `${CUSTOM_WIDGET_ITEM_ID}__${id}`;
  const isRendered = useRef(false);
  const { ready: isPageReady } = useAppSelector(selectPage);
  const scriptSrc = (script == null ? void 0 : script.src) || null;
  const scriptStatus = useScript(scriptSrc, script == null ? void 0 : script.options);
  const linkHref = (link == null ? void 0 : link.href) || null;
  const linkStatus = useLink(linkHref, link == null ? void 0 : link.options);
  const isScriptExist = !!scriptSrc;
  const isScriptLoaded = scriptSrc && scriptStatus === LoadingEnum.Succeeded;
  const isScriptReady = isScriptLoaded || !isScriptExist;
  const isLinkExist = !!linkHref;
  const isLinkLoaded = linkHref && linkStatus === LoadingEnum.Ready;
  const isLinkReady = isLinkLoaded || !isLinkExist;
  const isReadyToRender = isPageReady && isScriptReady && isLinkReady;
  useEffect(() => {
    if (isRendered.current || !isReadyToRender) {
      return;
    }
    try {
      render == null ? void 0 : render(itemId);
      isRendered.current = true;
    } catch (e) {
      const error = e;
      loggerApp.log([
        {
          type: "error",
          message: "Custom block",
          items: [
            {
              message: `An error occurred while rendering a custom block "${itemId}"`
            },
            {
              message: error.message
            }
          ]
        }
      ]);
    }
    return () => {
      try {
        destroy == null ? void 0 : destroy();
      } catch (e) {
        const error = e;
        loggerApp.log([
          {
            type: "error",
            message: "Custom block",
            items: [
              {
                message: `An error occurred while unmounting a custom block "${itemId}"`
              },
              {
                message: error.message
              }
            ]
          }
        ]);
      }
    };
  }, [isReadyToRender]);
  return {
    ...props,
    id: itemId
  };
};
export {
  useContainer
};
